import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BaseClass } from 'src/app/@shared/base-class/base-class';
import { IbaseService } from 'src/app/@shared/base-service/ibase-service';
import { MessageService } from 'src/app/@shared/message/message.service';
import { WebserviceService } from 'src/app/@shared/services/webservice.service';


@Component({
  selector: 'app-race-detail',
  templateUrl: './race-detail.component.html',
  styleUrls: ['./race-detail.component.css']
})
export class RaceDetailComponent extends BaseClass<any> implements OnInit {

  @Input() data: any;
  @Output() betDt = new EventEmitter();
  @Output() updateData = new EventEmitter();
  @Output() changeExpo = new EventEmitter();
  @Output() closeBet = new EventEmitter();

  public marketData: any;
  public event_type_id: any;
  public odds: any;
  public expo: any;
  public nextExpo: any;

  public betSlipData: any;

  constructor(public service: WebserviceService, public _message: MessageService) { super(document); }

  ngOnInit(): void {
  }

  getServices(): IbaseService<any> {
    return this.service;
  }

  trackByIndex(index: number, obj: any): any {
    return index;
  }

  openBetPlace(item: any, oddsItem: any, i: any, bet: any, oi: any, bkOrLy: any, key: string) {
    this.betDt.emit({ item: item, oddsItem: oddsItem, i: i, bet: bet, oi: oi, bkOrLy: bkOrLy, key: key })
  }

  ngOnChanges() {
    if (this.data) {
      this.marketData = this.data?.marketData;
      this.event_type_id = this.data?.event_type_id;
      this.odds = this.data?.odds;
      this.expo = this.data?.expo;
      this.nextExpo = this.data?.nextExpo;
      this.betSlipData = this.data?.betSlipData;
    }
  }

  volumeMultiSize(size: any, multi: any) {
    let num = (multi) ? Number(size) * Number(multi) : size;
    return (num % 1 != 0) ? Number(num).toFixed(2) : num;
  }

  getTitle(e: any) {
    e['isSuspend'] = false;
    let status: any = '';

    if (this.odds[`${e.market_id}`] && (this.odds[`${e.market_id}`]?.status === 'OPEN' || this.odds[`${e.market_id}`]?.status === 'CLOSED')) {
      if (this.odds[`${e.market_id}`] && this.odds[`${e.market_id}`]?.cRunners[e?.selection_id]?.status != '' && this.odds[`${e.market_id}`]?.cRunners[e?.selection_id]?.status != 'ACTIVE') {
        status = this.odds[`${e.market_id}`]?.cRunners[e?.selection_id]?.status;
        e['isSuspend'] = true;
      } else if (this.marketData?.bet_allow == 0) {
        e['isSuspend'] = true;
      }
    } else if (this.odds[`${e.market_id}`]) {
      status = this.odds[`${e.market_id}`]?.status
      e['isSuspend'] = true;
    }

    e['susStatus'] = status;
    // return status;
  }

  openBetPlaceLay() {
    this._message.errmessage('Lay bet is not allowed on this market !')
  }

  ngAfterContentChecked() {
    this.marketData?.runners.forEach((element: any, i: any) => {
      this.getTitle(element);
    });
  }

}
